const concatenate = (...args: (string | null)[]) => args.filter(Boolean).join(', ');

export default concatenate;
